import styled, { keyframes, css } from "styled-components";
const blurness = keyframes`
  0%{
    filter:blur(0px);
    transform: translateZ(0) scale(1);
  }
 
  100% {
    transform: translateZ(0) scale(0.9);
    filter:blur(7px);
    transition-timing-function: cubic-bezier(0.33,0,0,1);
  }
`;
const blurnessReverse = keyframes`
 0%{
   filter:blur(7px);
   transform: translateZ(0) scale(0.9);
  }
  100%{
    filter:blur(0px);
    transform: translateZ(0) scale(1);
    transition-timing-function: cubic-bezier(0.33,0,0,1);
  }
`;

const blurAnimReverse = css`
  ${blurnessReverse}
`;
const blurnessAnim = css`
  ${blurness}
`;

export const AppContainer = styled.div`
  height: 100%;
  width: 100%;
  pointer-events: ${(p) => (p.isDisabled ? "none" : "auto")};
  ::-webkit-scrollbar {
    display: none;
  }
  & > div ::-webkit-scrollbar {
    display: none;
  }
`;
export const GameContainer = styled.div`
  position: relative;
  backface-visibility: hidden;
  touch-action: manipulation;
  pointer-events: ${(p) => (p.isDisabled ? "none" : "auto")};
`;

export const GameWrapper = styled.div`
  position: relative;
  overflow: hidden;
  animation: ${(p) =>
    p.aboveA ? blurnessAnim : !p.aboveA ? blurAnimReverse : null};
  animation-fill-mode: ${(p) => (!!p.blur ? "forwards" : null)};
  animation-duration: 0.167s;
  backface-visibility: hidden;
`;
